import type {
  ClerkOrganization,
  ClerkOrganizationMembership,
} from '@saaga/shared/interfaces/auth.interface'

export const getTimestamp = (date: Date | number | null | undefined): number => {
  if (!date) return Date.now()
  if (date instanceof Date) return date.getTime()
  return date
}

interface OrganizationInput {
  id: string
  name: string
  slug: string | null
  imageUrl: string
  membersCount: number | undefined
  createdAt: Date
  updatedAt: Date
}

interface MembershipInput {
  id: string
  organization: { id: string; name: string; slug: string | null; imageUrl: string }
  role: string
  createdAt: Date
  updatedAt: Date
}

export const transformOrganization = (organization: OrganizationInput): ClerkOrganization => ({
  id: organization.id,
  name: organization.name,
  slug: organization.slug,
  imageUrl: organization.imageUrl,
  membersCount: organization.membersCount ?? null,
  createdAt: getTimestamp(organization.createdAt),
  updatedAt: getTimestamp(organization.updatedAt),
})

export const transformMembership = (membership: MembershipInput): ClerkOrganizationMembership => ({
  id: membership.id,
  organizationId: membership.organization.id,
  organizationName: membership.organization.name,
  organizationSlug: membership.organization.slug,
  organizationImageUrl: membership.organization.imageUrl,
  role: membership.role,
  createdAt: getTimestamp(membership.createdAt),
  updatedAt: getTimestamp(membership.updatedAt),
})
